var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullscreenEnter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Out"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104,72L152,72C165.166,72 176,61.166 176,48C176,34.834 165.166,24 152,24L48,24C34.834,24 24,34.834 24,48L24,152C24,165.166 34.834,176 48,176C61.166,176 72,165.166 72,152L72,104L188,220C192.242,224.242 198.001,226.628 204,226.628C209.999,226.628 215.758,224.242 220,220C224.242,215.758 226.628,209.999 226.628,204C226.628,198.001 224.242,192.242 220,188L104,72Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,292C215.758,287.758 209.999,285.372 204,285.372C198.001,285.372 192.242,287.758 188,292L72,408L72,360C72,346.834 61.166,336 48,336C34.834,336 24,346.834 24,360L24,464C24,477.166 34.834,488 48,488L152,488C165.166,488 176,477.166 176,464C176,450.834 165.166,440 152,440L104,440L220,324C224.242,319.758 226.628,313.999 226.628,308C226.628,302.001 224.242,296.242 220,292Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,24L360,24C346.834,24 336,34.834 336,48C336,61.166 346.834,72 360,72L408,72L292,188C287.758,192.242 285.372,198.001 285.372,204C285.372,209.999 287.758,215.758 292,220C296.242,224.242 302.001,226.628 308,226.628C313.999,226.628 319.758,224.242 324,220L440,104L440,152C440,165.166 450.834,176 464,176C477.166,176 488,165.166 488,152L488,48C488,34.834 477.166,24 464,24Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,336C450.834,336 440,346.834 440,360L440,408L324,292C319.758,287.758 313.999,285.372 308,285.372C302.001,285.372 296.242,287.758 292,292C287.758,296.242 285.372,302.001 285.372,308C285.372,313.999 287.758,319.758 292,324L408,440L360,440C346.834,440 336,450.834 336,464C336,477.166 346.834,488 360,488L464,488C477.166,488 488,477.166 488,464L488,360C488,346.834 477.166,336 464,336Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenEnter);
export default __webpack_public_path__ + "static/media/fullscreen-enter.67de1548d2b9b34aede6dd54fea0c74f.svg";
export { ForwardRef as ReactComponent };